import { DataBean } from "../../DataBean";


export class ProvisionByData extends DataBean {

    public async getProvisionCatalog(idProvisionData: any, idAccount: any, idEmploymentBonus: any, page: any, recordsPerPag: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProvisionCatalog_Number_Number_Number_Number_Number", [idProvisionData, idAccount, idEmploymentBonus, page, recordsPerPag]);
    }

}